import { useRef, useCallback, useEffect } from "react";

export function useDebounce(callback, delay = 300) {
    const timerRef = useRef(null);
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    const debouncedFn = useCallback((...args) => {
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => callbackRef.current(...args), delay);
    }, [delay]);

    const cancel = useCallback(() => clearTimeout(timerRef.current), []);

    useEffect(() => () => clearTimeout(timerRef.current), []);

    return [debouncedFn, cancel];
}
